export default "__VITE_ASSET__4bb5fe24__"